import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

function ToggleProductGroup(props) {
  const { index, productGroup, toggleProductGroup, method } = props;

  const getIcon = () => {
    if (method === 'add') {
      return faPlusCircle;
    } else {
      return faMinusCircle
    }
  }

  const getLinkId = (index) => {
    if (props.method === 'add') {
      return `add-productGroup-` + index;
    } else {
      return `remove-productGroup-` + index;
    }
  }

  return ( <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={getLinkId(index)}
        onClick={e => {
          e.preventDefault();
          toggleProductGroup( productGroup );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="align-middle cursor-pointer"
          pointerEvents="none"
          icon={getIcon()}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={getLinkId(index)}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        {method === 'add' && <FormattedMessage
          id="components.pages.orderManagement.createOrder.actions.select_product"/>}
        {method !== 'add' && <FormattedMessage
          id="components.pages.orderManagement.createOrder.actions.unselect_product"/>}
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { ToggleProductGroup };
